import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';

import hotelTemplate from './searchPageHotel/hotelTemplate.html';
import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';
import '@/css/desktop/tooltip.scss';
import componentsBannerTemplate from '@view/desktop/layout/parts/search/search__tour-usually-includes-js.phtml';
import '@/js/desktop/components/search/useFilters/styles/useFilters.css';
import '@/js/desktop/components/search/useFilters/styles/useFiltersBnr.scss';
import filterBannerTemplate from '@/js/desktop/components/search/useFilters/search__use-filters-banner-js.phtml';
import LotteryBanner from '@/js/desktop/components/search/lotteryBannerSerp/LotteryBanner';
import checkLotteryService from '@/js/common/Domain/Service/checkLottery';
import partialPaymentService from '@/js/common/Domain/Service/partialPayment';
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';

import CashbackHotelCardBannerView from '@/js/desktop/components/cashbackHotelCardBanner/cashbackHotelCardBanner';
import CashbackPartialPaymentTourBannerView from '@/js/desktop/components/partialPayment/cashbackPartialPaymentTourBanner/cashbackPartialPaymentTourBanner';
import PartialPaymentTourBannerView from '@/js/desktop/components/partialPayment/partialPaymentTourBanner/partialPaymentTourBanner';

import checkTourCashbackAvailable from '@/js/common/Domain/Service/checkTourCashbackAvailable';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';

const shoucaseUrl = getShowcasePath();

let SearchPageHotelViewModel = Backbone.Epoxy.Model.extend({
	defaults: {
		hotelIndex: null,
		componentsOrder: null,
		regionType: null,
		regionWithOffices: null,
		searchPageModel: null,
		hidePartialBanner: false
	},
	computeds: {
		filterBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				return this.checkBannerPosition(hotelIndex, componentsOrder, 'filterBanner') ? filterBannerTemplate({hotelIndex}) : '';
			}
		},
		lotteryBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				var $lotteryBanner = '';

				if (this.checkBannerPosition(hotelIndex, componentsOrder, 'lotteryBanner')) {
					$lotteryBanner = (new LotteryBanner()).$el;
				}

				return $lotteryBanner;
			}
		},
		componentsBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				return this.checkBannerPosition(hotelIndex, componentsOrder, 'tourIncludes') ? componentsBannerTemplate({hotelIndex}) : '';
			}
		},
	},
	checkBannerPosition: function (index, componentsOrder, componentName) {
		var step = 3,
			componentsLength = step * componentsOrder.length,
			elLength,
			componentsOrderElName;

		componentsOrderElName = componentsOrder[((index - 2) / step) % componentsOrder.length];
		if (_.isArray(componentsOrderElName)) {
			elLength = componentsOrderElName.length;
			var elIndex = parseInt((index / componentsLength)) % elLength;
			componentsOrderElName = componentsOrderElName[elIndex];
		}
		return componentsOrderElName === componentName;
	},
	initialize: function (options) {
		this.searchFormViewModel = options.searchFormViewModel;
	}
});

const SearchPageHotelView = Backbone.Epoxy.View.extend({
	el: '<div class="serpHotelCard"></div>',
	hotelTemplate,
	data: null,
	template: null,
	events: {
		"click .goToHotelWithId": "goToHotelWithId",
		"click .serpHotelCard__container": "setInCookieMinPrice",
		"click .goToHotel": "goToHotel",
		"mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange)": 'hotelClick',
		'click .banner-close': 'closeBanner'
	},
	closeBanner(e) {
		const currentTarget = e.currentTarget;
		const banerName = $(currentTarget).data('banner');
		const bannerPosition = $(currentTarget).data('index') + 1;
		const parent = currentTarget.parentElement;

		if (!parent) return;

		window.dataLayer.push({
			event: 'selectContent',
			selectContent:
				{
					prop: [
						{type: 'engageBanner', value: banerName}
					],
					prop2: [
						{type: 'position', value: bannerPosition}
					]
				}
		});

		$(parent).remove();
	},
	trackingHotelClick() {
		trackingService.trackSerpHotelPosition({
			hotels: this.collectionView.collection,
			selectedHotel: this.model,
			sortStrategy: this.collectionView.model.get('sortStrategy'),
		});
	},
    mindBoxTrackingHotelClick() {
        mindBoxService.trackViewSerpClick('serp_main', {
            searhPageModel: this.model,
            collectionViewModel: this.collectionView.model,
        });
    },

    hotelClick(e) {
		this.trackingHotelClick();
        this.mindBoxTrackingHotelClick();
        this.hrefUrl(e);
    },

	setInCookieMinPrice: function () {
		$.cookie("hotelMinPrice", this.model.get("priceWithOilTax"), {
			expires: 1 / 24 / 60 / 3,
			path: '/',
			domain: 'all'
		});
	},
	buildPhotos: function () {
		var cover = this.model.get('cover'),
			photos = this.model.get('photos'),
			allPhotos = [],
			html = '',
			randomPhoto;

		if (!this.model.get('imagesHtml')) {
			if (cover) {
				allPhotos.unshift(cover);
			}

			if (photos && photos.length) {
				allPhotos = allPhotos.concat(photos);
			}

			_.each(allPhotos, function (photo) {
				html += '<li><a href="#" data-src="' + imageProxy(photo, {
					width: 300,
					height: 220
				}) + '"></a></li>';
			});

			if (photos && photos.length) {
				randomPhoto = allPhotos[Math.round(Math.random() * (photos.length - 1))];
				html += '<li class="lastPhotoLink"><a class="img" href="#" data-src="' + imageProxy(randomPhoto, {
					width: 300,
					height: 220
				}) + '"></a><a href="#" class="btn">Смотреть все фото</a></li>';
			}

			this.model.set('imagesHtml', html);
			this.renderPhotos();
		}
	},
	renderPhotos: function () {
		var imagesHtml = this.model.get('imagesHtml'),
			$modelElement = this.model.$element,
			$imagesPlace = $('.imagesHtml', $modelElement),
			$carousel = $('.js-images-carousel', $modelElement);

		if (imagesHtml) {
			if ($imagesPlace.length) {
				$imagesPlace.html(imagesHtml);
			}

			if (_.isObject($carousel.data('jcarousel'))) {
				$carousel.jcarousel('reload', {
					animation: 'fast'
				});
				$carousel.jcarousel('scroll', 0, false);
			}
		}
	},
	selectTemplate: function () {
		return this.template;
	},
	componentsList: function () {
		return [
			'filterBanner',
			'tourIncludes',
			'lotteryBanner',
			'partialPayment'
		];
	},
	render: function () {
		var template,
			self = this,
			data = this.model.toJSON({computed: true}),
			hotelIndex = self.collectionView.collection.indexOf(self.model);

		if (self.collectionView) {
			template = this.selectTemplate();
		}

		data.originalHotelObject = this.model;

		self.viewModel = new SearchPageHotelViewModel({
			hotelIndex: hotelIndex,
			componentsOrder: self.componentsList(),
			regionType: self.collectionView.model.get('regionType'),
			regionWithOffices: self.collectionView.model.get('regionWithOffices'),
			searchPageModel: self.collectionView.model,
			searchFormViewModel: self.searchFormViewModel,
		});

		this.$el.html(template(data));

        if (this.hotelMapView) {
            this.hotelMapView.reRender({
                data,
                $el: this.$el,
                parentModel: this.model,
                collectionView: this.collectionView,
            });
        } else {
            this.$el.html(template(data));
        }

		setTimeout(function () {
			self.applyBindings();
		}, 0);

		this.data = data;

		this.initCarousel();
		this.initSubscribes();
		this.renderPhotos();
		this.initSubViews();
		this.showBottomBanner();
	},

    showBottomBanner() {
        const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();
        const hasTourCashbackAvailable = checkTourCashbackAvailable(this.model.get('tourProducts'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }

            this.initCashbackBanner();
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    },

    getPartialPaymentData() {
        const tourProducts = this.model.get('tourProducts');
        const tourProduct = tourProducts?.at(0);

        const isVisible = !!tourProduct.get('firstPaymentDefinition')?.id;
        const countryName = this.model.get('country').get('name');

        return {
            isVisible,
            countryName,
            tourProducts,
        };
    },

    initPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        new PartialPaymentTourBannerView({
            el: this.$el.find('.partialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        new CashbackPartialPaymentTourBannerView({
            el: this.$el.find('.cashbackPartialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackBanner() {
        new CashbackHotelCardBannerView({
            el: $('.serpHotelCard__container', this.$el),
        });
    },

	initSubViews:function() {
		this.warrantyTooltip = new TooltipPopoverHtml({
			el: $('.js-warranted-icon', this.$el),
		});
	},
	initCarousel: function () {
		$('.js-images-carousel', this.$el).jcarousel({
			list: '.list',
			items: 'li',
			wrap: 'both',
			vertical: false
		}).on('jcarousel:visiblein', 'li', function (event, carousel) {
			var $element = $('a:not(.btn)', this);

			$element.css('background-image', 'url("' + $element.data('src') + '")');
		});

		$('.js-images-carousel-control-prev', this.$el).jcarouselControl({
			target: '-=1'
		});

		$('.js-images-carousel-control-next', this.$el).jcarouselControl({
			target: '+=1'
		});
	},
	reRender: function (model) {
		this.render();
	},
	initSubscribes: function () {
		var self = this;

		this.model.on('change:minPrice', $.proxy(this.reRender, this));
		this.model.on('change:tourProducts', $.proxy(this.reRender, this));
		this.model.on('change:photos', $.proxy(this.buildPhotos, this));


		if (this.collectionView) {

			this.collectionView.model.on('change:regionType', function (model, value) {
				self.viewModel.set('regionType', value);
			});
			this.collectionView.model.on('change:regionWithOffices', function (model, value) {
				self.viewModel.set('regionWithOffices', value);
			});
		}
	},
	searchFormViewModel: null,
	getComponentsData: function () {
		var self = this,
			countries = self.viewModel.get('searchPageModel').get('searchData').get('countries');
		checkLotteryService(function () {
			self.viewModel.set('componentsOrder', self.componentsList());
		});
		if (countries.length === 1) {
			partialPaymentService.getByCountry({
				countryId: countries.at(0).get('id'),
				callback: function (data) {
					if (data) {
						self.viewModel.set('componentsOrder', self.componentsList());
					}
				}
			})
		}
	},
	initialize: function (options) {
		var self = this;

		this.collectionView = options.collectionView;
		this.dataLayerAnalytics = options.collectionView.dataLayerAnalytics;
		this.template = options.template ? options.template : this.hotelTemplate;
        this.hotelMapView = options.hotelMapView;
		this.model.$element = this.$el;

		this.render();
		this.getComponentsData();
	},
	hrefUrl: function (event) {
		var identity = $(event.currentTarget).data('identity'),
			urlParams = toRouterHotelHydrator({
				tourCriteria: this.model.get('tourProducts').at(0).get('tourCriteria'),
				similar: this.model.get('similar') ? true : false
			}),
			hotelUrl = shoucaseUrl + '/hotel/' + this.model.get('id'),//this.model.get('url'),
			target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
			$target = $(event.currentTarget);


		if (typeof identity !== 'undefined') {
			urlParams['identity'] = identity;
			if (event.which == 2) {
				gaAsync(function () {
					ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', {'nonInteraction': 1})
				});
			}
		} else {
			if (event.which == 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
				gaAsync(function () {
					ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', {'nonInteraction': 1})
				});
			}
		}
		if ($target.hasClass('distance')) {
			urlParams['toMap'] = true;
		}
		urlParams.sid = searchSessionService.getSearchId();
		$(event.currentTarget).attr('href', hotelUrl + '#?' + $.param(urlParams));
		$(event.currentTarget).attr('target', target);
		ls.set('isAbsent', false);
	},
	goToHotelWithId: function (event, param2, param3) {
		var identity = $(event.currentTarget).data('identity'),
			tourProduct = this.model.get('tourProducts').findWhere({id: identity}),
			tourCriteria = typeof (tourProduct) == 'undefined' ? null : tourProduct.get('tourCriteria');

		if (tourCriteria !== null) {
			var urlParams = toRouterHotelHydrator({
					tourCriteria: tourCriteria,
					identity: identity,
					similar: this.model.get('similar') ? true : false
				}),
				target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
				hotelUrl =  `${shoucaseUrl}/hotel/${this.model.get('id')}`;

			urlParams.sid = searchSessionService.getSearchId();
			window.open(hotelUrl + '#?' + $.param(urlParams), target);
			ls.set('isAbsent', false);
		}
		return false;
	},
	goToHotel: function (event) {
		var tourCriteria = this.model.get('tourProducts').at(0).get('tourCriteria'),
			urlParams = toRouterHotelHydrator({
				tourCriteria: tourCriteria,
				similar: this.model.get('similar') ? true : false
			}),
			$target = $(event.currentTarget),
			target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
			hotelUrl =  `${shoucaseUrl}/hotel/${this.model.get('id')}`;

		if ($target.hasClass('distance')) {
			urlParams['toMap'] = true;
		}
		if ($target.hasClass('hotel-reviews')) {
			urlParams['toReviews'] = true;
		}
		urlParams.sid = searchSessionService.getSearchId();

		window.open(hotelUrl + '#?' + $.param(urlParams), target);
		ls.set('isAbsent', false);

		return false;
	},
	offerClick: function () {
	}
});

export default SearchPageHotelView;
